import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import CurrentRead from "@/components/CurrentRead";
import ReadingCard from "@/components/ReadingCard";
import BookModal from "@/components/BookModal";
import Reveal from "@/components/Reveal";
import EmailCaptureCTA from "@/components/EmailCaptureCTA";

export default function Books() {
  const [upcoming, setUpcoming] = useState([]);
  const [modalBook, setModalBook] = useState(null);

  useEffect(() => {
    api.get("/books", { params: { category: "upcoming" } }).then(({ data }) => {
      const sorted = (data || []).slice().sort((a, b) => (a.reading_order || a.month || 0) - (b.reading_order || b.month || 0));
      setUpcoming(sorted);
    });
  }, []);

  return (
    <div data-testid="books-page">
      <PageHeader overline="The Reading Library" script="Good books." title="Our Books" subtitle="What we're reading now, and what's coming next. Stories by Black women and authors that spark real conversation." />

      <section className="py-20 bg-mahogany-900">
        <div className="max-w-6xl mx-auto px-6">
          <Reveal className="mb-10 text-center"><p className="overline mb-3">Now Reading</p><h2 className="font-serif text-4xl sm:text-5xl font-light text-cream">Currently Reading</h2></Reveal>
          <Reveal><CurrentRead /></Reveal>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-b from-mahogany-950 to-mahogany-900">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal className="mb-12 text-center"><p className="overline mb-3">Coming Up</p><h2 className="font-serif text-4xl sm:text-5xl font-light text-cream">Upcoming Reads</h2></Reveal>
          {upcoming.length ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
              {upcoming.map((b, i) => <Reveal key={b.id} delay={i * 0.05}><ReadingCard book={b} onView={setModalBook} /></Reveal>)}
            </div>
          ) : (
            <p className="text-cream/50 text-center py-12">Upcoming selections are being curated — check back soon.</p>
          )}
        </div>
      </section>

      <BookModal book={modalBook} open={!!modalBook} onClose={() => setModalBook(null)} />
      <EmailCaptureCTA />
    </div>
  );
}
